// Colors are used on cluster overview
const statuses = [{
  value: 'DATAUP_SUCCESS',
  color: '#4caf50'
}, {
  value: 'JOIN_SUCCESS',
  color: '#8bc34a'
}, {
  value: 'DATAUP_MIC_ERR',
  color: '#ffb74d'
}, {
  value: 'JOIN_MIC_ERR',
  color: '#ffa726'
}, {
  value: 'JOIN_APPEUI_ERR',
  color: '#ff9800'
}, {
  value: 'JOIN_DEVNONCE_ERR',
  color: '#fb8c00'
}, {
  value: 'JOIN_DEVADDR_ERR',
  color: '#f57c00'
}, {
  value: 'NEVER_SEEN',
  color: '#bbb'
}]

export default statuses
